import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contribute-line-next",
  "use": "icon-contribute-line-next-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-contribute-line-next\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.97102 6C2.72551 5.74748 0.128854 3.19209 0.00465096 0H1.00563C1.13633 2.77661 3.528 5.0205 6.5 5.0205H9.5C9.77614 5.0205 10 5.24436 10 5.5205C10 5.74725 9.84906 5.93875 9.64217 6H5.97102Z\" fill=\"#FF0000\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol